import { Outlet, useLocation } from "react-router-dom";
import BackButton from "./components/back-button/backButton";

export default function Layout() {
  const { pathname } = useLocation();
  const isAuthPage =
    pathname === "/" ||
    pathname === "/login" ||
    pathname === "/register" ||
    pathname.startsWith("/reset") ||
    pathname.startsWith("/verify");

  return (
    <main className={`App ${isAuthPage ? "App--auth" : "App--portal"}`}>
      {!isAuthPage && (
        <div className="travel-page-decor" aria-hidden="true">
          <img
            className="travel-page-decor__topography"
            src="/travel-theme/topography-coral.webp"
            alt=""
          />
          <img
            className="travel-page-decor__city"
            src="/travel-theme/city-blue.webp"
            alt=""
          />
        </div>
      )}
      <BackButton />
      <Outlet />
    </main>
  );
}
